import { FC } from 'react';

import Form from 'src/components/Search/Common/Filters/Form';
import ResetAll from 'src/components/Search/Common/Filters/ResetAll';
import SearchLanguageLink from 'src/components/Search/Common/Filters/SearchLanguageLink';
import { useIsZarplataPlatform } from 'src/hooks/usePlatform';

import Age from 'src/components/Search/Resume/Filters/Age';
import Area from 'src/components/Search/Resume/Filters/Area';
import Citizenship from 'src/components/Search/Resume/Filters/Citizenship';
import District from 'src/components/Search/Resume/Filters/District';
import DriverLicense from 'src/components/Search/Resume/Filters/DriverLicenseTypes';
import EducationLevel from 'src/components/Search/Resume/Filters/EducationLevel';
import Employment from 'src/components/Search/Resume/Filters/Employment';
import Etc from 'src/components/Search/Resume/Filters/EtcFilter';
import IndustryWithPeriod from 'src/components/Search/Resume/Filters/ExpIndustryWithPeriod';
import Experience from 'src/components/Search/Resume/Filters/Experience';
import Gender from 'src/components/Search/Resume/Filters/Gender';
import GeoFilters from 'src/components/Search/Resume/Filters/Geo';
import {
    useGeoFiltersRedesignExp,
    useGeoFiltersMetroRedesignExp,
} from 'src/components/Search/Resume/Filters/Geo/hooks/useGeoFiltersRedesignExp';
import JobSearchStatus from 'src/components/Search/Resume/Filters/JobSearchStatus';
import Label from 'src/components/Search/Resume/Filters/Labels';
import Language from 'src/components/Search/Resume/Filters/Language';
import Metro from 'src/components/Search/Resume/Filters/Metro';
import ProfessionalRole from 'src/components/Search/Resume/Filters/ProfessionalRole';
import Relocation from 'src/components/Search/Resume/Filters/Relocation';
import Salary from 'src/components/Search/Resume/Filters/Salary';
import Schedule from 'src/components/Search/Resume/Filters/Schedule';
import SimilarResume from 'src/components/Search/Resume/Filters/SimilarResume';
import Skill from 'src/components/Search/Resume/Filters/Skill';
import TotalFilters from 'src/components/Search/Resume/Filters/Total';
import University from 'src/components/Search/Resume/Filters/University';
import VacancyContext from 'src/components/Search/Resume/Filters/VacancyId';
import VerifiedSkill from 'src/components/Search/Resume/Filters/VerifiedSkillsFilter';
import WorkTicket from 'src/components/Search/Resume/Filters/WorkTicket';

const ResumeSearchFilters: FC = () => {
    const isZpPlatform = useIsZarplataPlatform();

    const isGeoFiltersRedesignExp = useGeoFiltersRedesignExp(true);
    const isGeoFiltersMetroRedesignExp = useGeoFiltersMetroRedesignExp(true);

    return (
        <Form>
            {isGeoFiltersRedesignExp ? <GeoFilters /> : <TotalFilters />}
            <SimilarResume />
            <VacancyContext />
            {!isGeoFiltersRedesignExp && <Area />}
            {!isGeoFiltersRedesignExp && <District />}
            {!isGeoFiltersMetroRedesignExp && <Metro />}
            {!isZpPlatform && <Relocation />}
            {!isZpPlatform && <IndustryWithPeriod />}
            <JobSearchStatus />
            <Age />
            <Employment />
            <Schedule />
            <Experience />
            <ProfessionalRole />
            <Gender />
            <Salary />
            {!isZpPlatform && <Citizenship />}
            <Label />
            <EducationLevel />
            <University />
            {!isZpPlatform && <VerifiedSkill />}
            {!isZpPlatform && <Skill />}
            <Etc />
            {!isZpPlatform && <WorkTicket />}
            <DriverLicense />
            {!isZpPlatform && <Language />}
            <ResetAll />
            <SearchLanguageLink />
        </Form>
    );
};

export default ResumeSearchFilters;
